import { SupabaseService } from "../../../server/supabase/base-supabase-service";

export class SupabaseEmailMomentService extends SupabaseService<"email_moment"> {
  table = "email_moment" as const;
}
